export const photos = [
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/1.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/2.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/3.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/4.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/5.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/6.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/7.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/8.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/9.jpg`,
		width: 4,
		height: 3,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/10.jpg`,
		width: 4,
		height: 2,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/12.jpg`,
		width: 1,
		height: 1,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/13.jpg`,
		width: 1,
		height: 1,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/17.jpg`,
		width: 3,
		height: 1,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/18.jpg`,
		width: 2,
		height: 1,
      links: ''
	},

	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/20.jpg`,
		width: 2,
		height: 1,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/21.jpg`,
		width: 2,
		height: 2,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/22.jpg`,
		width: 4,
		height: 2,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/23.jpg`,
		width: 2,
		height: 2,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/24.jpg`,
		width: 4,
		height: 2,
      links: ''
	},
	{
		src: `${process.env.PUBLIC_URL}/assets/galeri/25.jpg`,
		width: 2,
		height: 2,
      links: ''
	},
	
];
